import { render, staticRenderFns } from "./CollectionSelector.vue?vue&type=template&id=50f2d1be&scoped=true&"
import script from "./CollectionSelector.vue?vue&type=script&lang=js&"
export * from "./CollectionSelector.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSelector.vue?vue&type=style&index=0&id=50f2d1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2d1be",
  null
  
)

export default component.exports